'use client'
import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { ReportErrorDto, ReportErrorResponse } from '../../lib'
import { methods } from '@/shared/api/constants'

const reportError = async (dto: ReportErrorDto): Promise<Partial<ReportErrorResponse> | undefined> => {
  const res = await api.json<Partial<ReportErrorResponse>>(API_END_POINTS.errors.reportError, {
    method: methods.post,
    body: JSON.stringify(dto),
  })

  if (res.ok) return res.result
  throw new Error(res?.message || res?.error)
}

export default reportError
